export default ({children,
  content,
  text,
  className = "", 
  position = "top",
  color = "" 
}) => {

  // Définir les classes de position
  const positionClasses = {
    top: 'tooltip-top',
    right: 'tooltip-right',
    bottom: 'tooltip-bottom',
    left: 'tooltip-left',
  }

  const colorClasses = {
    neutral: 'tooltip-neutral',
    primary: 'tooltip-primary',
    secondary: 'tooltip-secondary',
    accent: 'tooltip-accent',
    info: 'tooltip-info',
    success: 'tooltip-success',
    warning: 'tooltip-warning',
    error: 'tooltip-error'
  }

  let styleClasses = `${className} tooltip ${positionClasses[position]} `
  if(color) {
    styleClasses += colorClasses[color]
  }

  const tooltipProps = {}
  if(text) {
    tooltipProps['data-tip'] = text
  }

  return (
    <div className={styleClasses} {...tooltipProps}>
      { content && <div className="tooltip-content">{content}</div>}
      { children }
    </div>
  )
}